module.exports = __webpack_public_path__ + "aee1d7a5d91b91cfaa5adb282ed51b7e.svg";